module.exports = "<pre><code class=\"lang-html\">&lt;v-stepper :steps=&quot;steps&quot; v-model=&quot;step&quot;&gt;&lt;/v-stepper&gt;\n\n&lt;!-- Change routes by step --&gt;\n&lt;router-view&gt;&lt;/router-view&gt;\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./src/markdowns/vuex/component-template.md
// module id = BVlo
// module chunks = 1